module.exports = __webpack_public_path__ + "img/s1.702c1f31.png";